// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page-profile {
  min-height: 200px;
  background-color: white;
  border-radius: 4px;
}
.profile-page-profile .profile-page-profile-user {
  height: 50px;
  border-radius: 3px 3px 0px 0px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: white;
  padding: 0px 0px 40px 0px;
}
.profile-page-profile .profile-page-profile-user .profile-page-profile-name {
  font-size: 20px;
  font-weight: 400;
}
.profile-page-profile .profile-page-profile-avatar {
  height: 60px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-page-profile .profile-page-profile-avatar img {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  position: absolute;
  top: -45px;
  box-shadow: 0px 0px 5px 1px grey;
}
.profile-page-profile .profile-page-profile-avatar .profile-page-profile-username {
  font-size: 14px;
  color: white;
  position: absolute;
  top: -30px;
  right: 20px;
}
.profile-page-profile .profile-page-content-network {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 25px;
  padding: 10px 0px;
}
.profile-page-profile .profile-page-content-network img {
  width: 35px;
}
.profile-page-profile .profile-page-profile-list {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.profile-page-profile .profile-page-profile-list .profile-page-profile-list-line {
  width: 100%;
  max-width: 1px;
  background-color: rgba(128, 128, 128, 0.212);
  height: 100%;
}
.profile-page-profile .profile-page-profile-list .profile-page-profile-list-item {
  height: 100%;
  width: 100%;
  max-width: calc(25% - 1px);
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
}
.profile-page-profile .profile-page-profile-list .profile-page-profile-list-item .profile-page-profile-list-item-title {
  display: flex;
  gap: 5px;
  font-size: 13px;
  align-items: center;
}
.profile-page-profile .profile-page-profile-list .profile-page-profile-list-item .profile-page-profile-list-item-title img {
  width: 15px;
}
@media only screen and (max-width: 792px) {
  .profile-page-profile .profile-page-profile-list {
    height: auto;
    display: grid;
    grid-template-columns: auto auto;
    padding-bottom: 10px;
  }
  .profile-page-profile .profile-page-profile-list .profile-page-profile-list-line {
    display: none;
  }
  .profile-page-profile .profile-page-profile-list .profile-page-profile-list-item {
    max-width: 100%;
  }
}
.profile-page-profile .profile-page-profile-button {
  height: 70px;
  padding: 0px 15px;
}

.profile-page-info {
  width: 100%;
  min-height: 200px;
  background-color: white;
  border-radius: 4px;
}
.profile-page-info .profile-page-info-top {
  height: 7px;
  background-color: #ff5cb5;
  border-radius: 4px 4px 0px 0px;
}
.profile-page-info .profile-page-info-content {
  width: calc(100% - 40px);
  padding: 10px 20px;
}
.profile-page-info .profile-page-info-content .profile-page-info-content-item {
  display: flex;
  gap: 10px;
}
.profile-page-info .profile-page-info-content .profile-page-info-content-item .pp-info-ci-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 1rem;
}
.profile-page-info .profile-page-info-content .profile-page-info-content-item .pp-info-ci-content .pp-info-ci-content-label {
  font-weight: bold;
}
.profile-page-info .profile-page-info-content .profile-page-info-content-item .pp-info-ci-content .pp-info-ci-content-text {
  font-weight: 400;
  color: grey;
}
.profile-page-info .profile-page-info-content .profile-page-info-content-line, .profile-page-info .profile-page-info-content .profile-page-info-content-line-2 {
  width: 100%;
  height: 1px;
  background-color: rgba(128, 128, 128, 0.315);
  margin: 10px 0px;
}
.profile-page-info .profile-page-info-content .profile-page-info-content-line-2 {
  display: none;
}
@media only screen and (max-width: 792px) {
  .profile-page-info .profile-page-info-content .profile-page-info-content-item {
    display: block;
  }
  .profile-page-info .profile-page-info-content .profile-page-info-content-line-2 {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/profile/ProfilePage.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAAI;EACI,YAAA;EAEA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,sBAAA;EACA,YAAA;EACA,yBAAA;AAAR;AACQ;EACI,eAAA;EACA,gBAAA;AACZ;AAGI;EACI,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAEQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,gCAAA;AAAZ;AAEQ;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAAZ;AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;AADR;AAEQ;EACI,WAAA;AAAZ;AAGI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADR;AAEQ;EACI,WAAA;EACA,cAAA;EACA,4CAAA;EACA,YAAA;AAAZ;AAEQ;EACI,YAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAAZ;AACY;EACI,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AAChB;AAAgB;EACI,WAAA;AAEpB;AAGI;EACI;IACI,YAAA;IACA,aAAA;IACA,gCAAA;IACA,oBAAA;EADV;EAEU;IACI,aAAA;EAAd;EAEU;IACI,eAAA;EAAd;AACF;AAGI;EACI,YAAA;EACA,iBAAA;AADR;;AAKA;EACI,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AAFJ;AAGI;EACI,WAAA;EACA,yBAAA;EACA,8BAAA;AADR;AAGI;EACI,wBAAA;EACA,kBAAA;AADR;AAEQ;EACI,aAAA;EACA,SAAA;AAAZ;AACY;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AAChB;AAAgB;EACI,iBAAA;AAEpB;AAAgB;EACI,gBAAA;EACA,WAAA;AAEpB;AAEQ;EACI,WAAA;EACA,WAAA;EACA,4CAAA;EACA,gBAAA;AAAZ;AAEQ;EACI,aAAA;AAAZ;AAEQ;EACI;IACI,cAAA;EAAd;EAEU;IACI,cAAA;EAAd;AACF","sourcesContent":[".profile-page-profile {\n    min-height: 200px;\n    background-color: white;\n    border-radius: 4px;\n    .profile-page-profile-user {\n        height: 50px;\n        // background-color: #ff5cb5;\n        border-radius: 3px 3px 0px 0px;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        // gap: 5px;\n        flex-direction: column;\n        color: white;\n        padding: 0px 0px 40px 0px;\n        .profile-page-profile-name {\n            font-size: 20px;\n            font-weight: 400;\n        }\n        \n    }\n    .profile-page-profile-avatar {\n        height: 60px;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        img {\n            width: 90px;\n            height: 90px;\n            border-radius: 100%;\n            position: absolute;\n            top: -45px;\n            box-shadow: 0px 0px 5px 1px grey;\n        }\n        .profile-page-profile-username{\n            font-size: 14px;\n            color: white;\n            position: absolute;\n            top: -30px;\n            right: 20px;\n        }\n    }\n    .profile-page-content-network {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 20px;\n        min-height: 25px;\n        padding: 10px 0px;\n        img {\n            width: 35px;\n        }\n    }\n    .profile-page-profile-list {\n        height: 70px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        .profile-page-profile-list-line {\n            width: 100%;\n            max-width: 1px;\n            background-color: rgba(128, 128, 128, 0.212);\n            height: 100%;\n        }\n        .profile-page-profile-list-item {\n            height: 100%;\n            width: 100%;\n            max-width: calc(25% - 1px);\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n            align-items: center;\n            justify-content: center;\n            font-size: 14px;\n            font-weight: 500;\n            .profile-page-profile-list-item-title {\n                display: flex;\n                gap: 5px;\n                font-size: 13px;\n                align-items: center;\n                img {\n                    width: 15px;\n                }\n            }\n        }\n    }\n    @media only screen and (max-width: 792px) {\n        .profile-page-profile-list {\n            height: auto;\n            display: grid;\n            grid-template-columns: auto auto;\n            padding-bottom: 10px;\n            .profile-page-profile-list-line {\n                display: none;\n            }\n            .profile-page-profile-list-item {\n                max-width: 100%;\n            }\n        }\n    }\n    .profile-page-profile-button {\n        height: 70px;\n        padding: 0px 15px;\n    }\n}\n\n.profile-page-info {\n    width: 100%;\n    min-height: 200px;\n    background-color: white;\n    border-radius: 4px;\n    .profile-page-info-top {\n        height: 7px;\n        background-color: #ff5cb5;\n        border-radius: 4px 4px 0px 0px;\n    }\n    .profile-page-info-content {\n        width: calc(100% - 40px);\n        padding: 10px 20px;\n        .profile-page-info-content-item {\n            display: flex;\n            gap: 10px;\n            .pp-info-ci-content {\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: 5px;\n                font-size: 1rem;\n                .pp-info-ci-content-label {\n                    font-weight: bold;\n                }\n                .pp-info-ci-content-text {\n                    font-weight: 400;\n                    color: grey;\n                }\n            }\n        }\n        .profile-page-info-content-line, .profile-page-info-content-line-2 {\n            width: 100%;\n            height: 1px;\n            background-color: rgba(128, 128, 128, 0.315);\n            margin: 10px 0px;\n        }\n        .profile-page-info-content-line-2{\n            display: none;\n        }\n        @media only screen and (max-width: 792px) {\n            .profile-page-info-content-item {\n                display: block;\n            }\n            .profile-page-info-content-line-2{\n                display: block;\n            }\n        }\n        \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
